import {accessAdminActions} from './access-admin.actions';

const initialState = {
  // Slice 4c — mockup S7. Empty is the honest default: this route is gated on
  // access.delegation:activate, so a super user who is not a platform_admin sees no rows.
  nominations: [],
  activateError: '',
  subjects: [],
  currentSubject: null,
  assignments: [],
  // S3 (§3.2/§3.3): what they hold WITH provenance, and what they cannot do WITH the reason.
  canDo: [],
  cannotDo: [],
  // S1 (§3.4): the roster is the page, not a detail view reached through a picker.
  roster: {people: [], counts: {}, total: 0, expiring: {}},
  rosterFilters: {},
  audit: [],
  auditFilters: {},
  review: [],
  roles: [],
  // {instance: [...], schema: [...], connection: [...], context: [...]} — §3.9's picker options.
  scopeOptions: {},
  grantDrawerOpen: false,
  grantError: null, // {error, code} — see §5's error-code map
  error: '',
};

export function accessAdminReducer(state = initialState, action) {
  switch (action.type) {
    case accessAdminActions.SUBJECT_SEARCH_SUCCESS:
      return {...state, subjects: action.payload};
    case accessAdminActions.SUBJECT_SELECTED:
      return {...state, currentSubject: action.payload, assignments: [], canDo: [], cannotDo: []};
    case accessAdminActions.ASSIGNMENTS_LOAD_SUCCESS:
      return {...state, assignments: action.payload};
    case accessAdminActions.EFFECTIVE_LOAD_SUCCESS:
      return {...state, canDo: action.payload.canDo, cannotDo: action.payload.cannotDo};
    case accessAdminActions.ROSTER_LOAD_SUCCESS:
      return {...state, roster: action.payload};
    case accessAdminActions.ROSTER_FILTER_CHANGE:
      return {...state, rosterFilters: action.payload};
    case accessAdminActions.REVIEW_LOAD_SUCCESS:
      return {...state, review: action.payload};
    case accessAdminActions.AUDIT_FILTER_CHANGE:
      return {...state, auditFilters: action.payload};
    case accessAdminActions.AUDIT_LOAD_SUCCESS:
      return {...state, audit: action.payload};
    case accessAdminActions.ROLES_LOAD_SUCCESS:
      return {...state, roles: action.payload};
    case accessAdminActions.SCOPES_LOAD_SUCCESS:
      return {...state, scopeOptions: {...state.scopeOptions, [action.payload.scopeType]: action.payload.options}};
    case accessAdminActions.GRANT_DRAWER_OPEN:
      return {...state, grantDrawerOpen: true, grantError: null};
    case accessAdminActions.GRANT_DRAWER_CLOSE:
      return {...state, grantDrawerOpen: false, grantError: null};
    case accessAdminActions.GRANT_SUBMIT_SUCCESS:
      return {...state, grantDrawerOpen: false, grantError: null};
    case accessAdminActions.GRANT_SUBMIT_FAIL:
      return {...state, grantError: action.payload};
    case accessAdminActions.REVOKE_SUCCESS:
      return {...state, error: ''};
    case accessAdminActions.MUTATION_FAIL:
      return {...state, error: action.payload};
    case accessAdminActions.NOMINATIONS_LOAD_SUCCESS:
      return {...state, nominations: action.payload, activateError: ''};
    case accessAdminActions.ACTIVATE_FAIL:
      return {...state, activateError: action.payload};

    default:
      return state;
  }
}

export default accessAdminReducer;
